module.exports = __webpack_public_path__ + "01f43047/img/rename-icon.de4e673d.svg";